import React from 'react';
import { CalendarSyncImportWizardAction } from './CalendarSyncImportWizardActionContainer';
import { CalendarSyncImportWizardCompleted } from './CalendarSyncImportWizardCompleted';

interface ICalendarSyncImportWizardProps {
	propertyId: number | string;
	onRequestClose: () => any;
	step?: ImportWizardStep;
}

enum ImportWizardStep {
	ACTION = 1,
	COMPLETED = 2,
}

export const CalendarSyncImportWizard: React.FC<ICalendarSyncImportWizardProps> = ({ onRequestClose, propertyId, step }) => {
	const [wizardStep, setWizardStep] = React.useState(step || ImportWizardStep.ACTION);

	switch (wizardStep) {
		case ImportWizardStep.ACTION:
			return <CalendarSyncImportWizardAction
				propertyId={propertyId}
				onRequestNext={() => setWizardStep(wizardStep + 1)}
				onRequestPrevious={() => setWizardStep(wizardStep - 1)}
				onRequestClose={() => onRequestClose()}
			/>;
		case ImportWizardStep.COMPLETED:
			return <CalendarSyncImportWizardCompleted
				propertyId={propertyId}
				onRequestNext={() => setWizardStep(wizardStep + 1)}
				onRequestPrevious={() => setWizardStep(wizardStep - 1)}
				onRequestClose={() => onRequestClose()}
			/>;
		default:
			return <CalendarSyncImportWizardAction
				propertyId={propertyId}
				onRequestNext={() => setWizardStep(wizardStep + 1)}
				onRequestPrevious={() => setWizardStep(wizardStep - 1)}
				onRequestClose={() => onRequestClose()}
			/>;
	}
};
